import React from 'react';
import { FadeIn } from './FadeIn';
import { DownloadIcon } from 'lucide-react';
export function OfferSection() {
  return <section className="py-24 px-6 bg-navy-900 relative" data-id="element-111">
      <div className="absolute bottom-0 left-0 w-full h-1/2 bg-gradient-to-t from-teal-900/20 to-transparent pointer-events-none" data-id="element-112" />

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-113">
        <FadeIn data-id="element-114">
          <h2 className="font-serif text-3xl md:text-4xl font-bold mb-6 text-white" data-id="element-115">
            Recupera tu productividad y deja de vivir con miedo al próximo
            ataque.
          </h2>
          <p className="text-xl text-slate-300 mb-12" data-id="element-116">
            Obtén la hoja de ruta completa para dominar tus crisis migrañosas
            hoy mismo.
          </p>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-117">
          <div className="bg-navy-800 p-8 md:p-12 rounded-3xl border border-teal-500/30 shadow-2xl shadow-teal-900/20 max-w-2xl mx-auto" data-id="element-118">
            <img src="https://cdn.magicpatterns.com/uploads/jR8KGMcMY48YnErzQtEFFz/heylloyd-image-1775623115845.png" alt="Migraña Pro" className="w-full max-w-md mx-auto rounded-xl mb-8 shadow-lg" data-id="element-119" />

            <div className="mb-8" data-id="element-120">
              <span className="text-slate-400 uppercase tracking-wider text-sm font-semibold" data-id="element-121">
                Precio Sugerido
              </span>
              <div className="text-5xl font-bold text-white mt-2" data-id="element-122">$9.99</div>
            </div>

            <a href="https://vitalizateahora.com/cart/51953602822375:1" target="_blank" rel="noopener noreferrer" className="w-full bg-teal-500 hover:bg-teal-400 text-navy-900 font-bold text-lg py-4 px-8 rounded-xl transition-all transform hover:scale-[1.02] active:scale-[0.98] shadow-lg shadow-teal-500/25 flex items-center justify-center" data-id="element-123">
              ACCEDER AL PROTOCOLO AHORA
            </a>

            <div className="mt-4 flex items-center justify-center text-sm text-slate-400" data-id="element-124">
              <DownloadIcon className="w-4 h-4 mr-2" data-id="element-125" />
              <span data-id="element-126">
                Descarga instantánea — PDF optimizado para dispositivos móviles.
              </span>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}